export default __webpack_public_path__ + "static/media/Websites-Washington post.25608407.png";